import React from "react";

/**
 * Reusable Download CSV dropdown with "Selected" and "All" options.
 */
const DownloadCsvDropdown = ({
  selectedCount = 0,
  loading = false,
  onDownloadSelected,
  onDownloadAll,
  buttonLabel = "Download CSV",
  className = "",
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        disabled={loading}
        onClick={() => setOpen((o) => !o)}
        className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 flex items-center gap-1"
      >
        {buttonLabel}
        <span className="text-xs text-gray-400">▼</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="absolute right-0 top-full mt-1 z-20 rounded-lg border border-gray-200 bg-white shadow-lg py-1 min-w-[160px]">
            <button
              type="button"
              onClick={() => { onDownloadSelected(); setOpen(false); }}
              disabled={loading || selectedCount === 0}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Selected ({selectedCount})
            </button>
            <button
              type="button"
              onClick={() => { onDownloadAll(); setOpen(false); }}
              disabled={loading}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 disabled:opacity-50"
            >
              All
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DownloadCsvDropdown;
